const create = {
  path: 'create',
  component: resolve => require(['@/pages/admin/merchant/signing/yftWeChat/accessPay/create'], resolve)
}

export default create
